import React from 'react';
import { Box } from '@mui/material';
import { useTabContext } from '../../contexts/TabContext';
import { ROUTE_COMPONENT_MAP } from './routeComponentMap';

const TabPanel: React.FC<{ path: string; isActive: boolean }> = React.memo(({ path, isActive }) => {
  const entry = ROUTE_COMPONENT_MAP[path];
  if (!entry) return null;
  const Component = entry.component;
  return (
    <Box
      sx={{
        display: isActive ? 'block' : 'none',
        height: '100%',
        width: '100%',
      }}
    >
      <Component />
    </Box>
  );
});

const TabContent: React.FC = () => {
  const { tabs, activeTabId } = useTabContext();

  return (
    <>
      {tabs.map((tab) => (
        <TabPanel
          key={tab.id}
          path={tab.path}
          isActive={tab.id === activeTabId}
        />
      ))}
    </>
  );
};

export default React.memo(TabContent);
